import { ArrayWidget } from './array.widget';
import { CheckboxWidget } from './checkbox.widget';
import { FileWidget } from './file.widget';
import { IntegerWidget } from './integer.widget';
import { ObjectWidget } from './object.widget';
import { RadioWidget } from './radio.widget';
import { RangeWidget } from './range.widget';
import { SelectWidget } from './select.widget';
import { StringWidget } from './string.widget';
import { TextAreaWidget } from './textarea.widget';
import { ButtonWidget } from './button.widget';
import { ButtonGroupWidget } from './buttongroup.widget';

import { MessageWidget } from './message.widget';
import { POPQWidget } from './popq.widget';
import { TagListWidget } from './taglist.widget';
import { DividerWidget } from './divider.widget';

import { DurationDaysWidget } from "./custom/durationdays.widget";

import { DefaultWidgetRegistry } from '../angular2-schema-form-shim';

export type WidgetType =
  'array' |
  'object' |
  'string' |
  'search' |
  'tel' |
  'url' |
  'email' |
  'password' |
  'color' |
  'date' |
  'date-time' |
  'time' |
  'integer' |
  'number' |
  'range' |
  'textarea' |
  'file' |
  'select' |
  'radio' |
  'boolean' |
  'checkbox' |
  'button' |
  'buttongroup' |
  'message' |
  'popq' |
  'taglist' |
  'divider' |
  'durationdays' |
  'hidden';

export type WidgetObject = {
  id: WidgetType,
  [ key: string ]: any,
}

export class SPWidgetRegistry extends DefaultWidgetRegistry {
  constructor() {
    super();

    this.register( 'array', ArrayWidget );
    this.register( 'object', ObjectWidget );
    this.register( 'string', StringWidget );
    this.register( 'search', StringWidget );
    this.register( 'tel', StringWidget );
    this.register( 'url', StringWidget );
    this.register( 'email', StringWidget );
    this.register( 'password', StringWidget );
    this.register( 'color', StringWidget );
    this.register( 'date', StringWidget );
    this.register( 'date-time', StringWidget );
    this.register( 'time', StringWidget );
    this.register( 'hidden', StringWidget );
    this.register( 'integer', IntegerWidget );
    this.register( 'number', IntegerWidget );
    this.register( 'range', RangeWidget );
    this.register( 'textarea', TextAreaWidget );
    this.register( 'file', FileWidget );
    this.register( 'select', SelectWidget );
    this.register( 'radio', RadioWidget );
    this.register( 'boolean', CheckboxWidget );
    this.register( 'checkbox', CheckboxWidget );
    this.register( 'button', ButtonWidget );
    this.register( 'buttongroup', ButtonGroupWidget );

    this.register( 'message', MessageWidget );
    this.register( 'popq', POPQWidget );
    this.register( 'taglist', TagListWidget );
    this.register( 'divider', DividerWidget );

    this.register( 'durationdays', DurationDaysWidget );

    this.setDefaultWidget( StringWidget );
  }

  register( type: WidgetType, widget ) {
    super.register( type, widget );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/registry.ts